import React, { createContext, useContext, useEffect, useState } from 'react';
import { media_list } from './configs';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
	const [config, setConfig] = useState(null);
	// const [loadingConfig, setLoadingConfig] = useState(true);
	const [faviconUrl, setFaviconUrl] = useState(null);
	const [domain, setDomain] = useState(null);
	const location = useLocation();

	const extractMainPart = (url) => {
		const hostname = new URL(url).hostname;
		const parts = hostname.split('.');
		if (parts.length === 2) {
			return parts[0];
		} else if (parts.length > 2) {
			return parts[parts.length - 2];
		}
		return null;
	};

	const isTrustedSource = (src) => {
		const trustedSources = [
			'https://www.googletagmanager.com/gtag/js',
			// add more source
		];
		return trustedSources.some(trusted => src.startsWith(trusted));
	};

	const isSafeInlineScript = (script) => {
		const forbiddenPatterns = [
			/eval\(/,
			/document\.cookie/,
			/window\.location/,
			/alert\(/,
			/console\./,
			/fetch\(/,
			/XMLHttpRequest/,
			/setTimeout\(/,
			/setInterval\(/,
			/window\.open\(/,
			/window\.close\(/,
			/document\.write\(/,
		];
		return !forbiddenPatterns.some(pattern => pattern.test(script));
	};

	const sanitizeScripts = (analyticsContent) => {
		if (!analyticsContent) return { cleanup: () => {}, safeScripts: '' };

		const scripts = [];
		let safeScripts = '';

		// sanitizing
		const scriptMatches = analyticsContent.match(/<script.*?<\/script>/g) || [];
		scriptMatches.forEach(scriptTag => {
			const newScript = document.createElement('script');
			const srcMatch = scriptTag.match(/src=['"](.*?)['"]/);
			if (srcMatch) {
				const scriptSrc = srcMatch[1];
				if (isTrustedSource(scriptSrc)) {
					newScript.src = scriptSrc;
					newScript.async = true;
					document.head.appendChild(newScript);
					scripts.push(newScript);
					safeScripts += `<script async src='${scriptSrc}'></script>`;
				} else {
					console.error(`⚠️   WARNING: Untrusted script source detected   ⚠️
					
🔴 Source: ${scriptSrc} 🔴`);
				}
			} else {
				const inlineScriptContent = scriptTag.replace(/<script.*?>|<\/script>/g, '');
				if (isSafeInlineScript(inlineScriptContent)) {
					newScript.innerHTML = inlineScriptContent;
					document.head.appendChild(newScript);
					scripts.push(newScript);
					safeScripts += `<script>${inlineScriptContent}</script>`;
				} else {
					console.error(`⚠️   WARNING: Unsafe inline script detected!   ⚠️
					
🚨 Script content: ${inlineScriptContent} 🚨`);
				}
			}
		});

		return {
			cleanup: () => {
				scripts.forEach(script => {
					document.head.removeChild(script);
				});
			}, safeScripts,
		};
	};

	useEffect(() => {
		const domain = window.location.origin; // fetch domain
		// const domain = 'https://bebin.com';

		setDomain(domain);
		const domainName = extractMainPart(domain);
		const mediaData = media_list[domainName?.toUpperCase()];

		const domainParts = domain.split('.');
		let subDomain = null;

		if (domainParts.length > 2) {
			subDomain = domainParts.slice(0, domainParts.length - 2).join('.')
		}

		let isMounted = true;

		if (isMounted) {
			if (domainName !== 'bebin' || (domainName === 'bebin' && subDomain)) {
				const fetchData = async () => {
					try {
						const response = await fetch(`https://api.elitland.com/api/v1/webview?media_url=${domain}`);
						const result = await response.json();
						const data = result.data;
						if (!data.errors) {
							const { cleanup, safeScripts } = sanitizeScripts(data.analytics); // بارگذاری اسکریپت‌ها و گرفتن تابع cleanup

							const updatedData = {
								...data,
								logo: data?.logo || mediaData?.logo,
								titleEn: domainName,
								title: data?.title || '',
								analytics: safeScripts,
								media_id: data?.media_id || '',
								...(subDomain !== null && domainName === 'bebin' && {
									sub_domain: subDomain,
								}),
							};

							setConfig(updatedData);

							// Remove scripts when unmounting
							return cleanup;
						} else {
							if (media_list[domainName?.toUpperCase()]) {
								setConfig(media_list[domainName?.toUpperCase()]);
							} else {
								const updatedData = {
									logo: '',
									titleEn: domainName,
									analytics: '',
									media_id: ''
								};

								setConfig(updatedData);
								return null;
							}
							// unmount
							return null;
						}
					} catch (error) {
						console.error("error::", error);
						if (media_list[domainName?.toUpperCase()]) {
							setConfig(media_list[domainName?.toUpperCase()]);
						} else {
							const updatedData = {
								logo: '',
								titleEn: domainName,
								analytics: '',
								media_id: ''
							};
							setConfig(updatedData);
						}
						console.error("Failed to fetch config:", error);
						// unmount
						return null;
					}
				};

				fetchData();
			} else {
				setConfig(media_list[domainName?.toUpperCase()]);
			}
		}


		// تابع پاک‌سازی
		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		if (config?.logo) {
			const domainName = extractMainPart(domain);
			const domainParts = domain.split('.');
			let subDomain = null;

			if (domainParts.length > 2) {
				subDomain = domainParts.slice(0, domainParts.length - 2).join('.')
			}

			if (domainName !== 'bebin' || (domainName === 'bebin' && subDomain)) {
				const faviconUrl = require(`../../../assets/images/${config?.logo}`).default;
				setFaviconUrl(faviconUrl)
			} else {
				const faviconUrl = require(`../../../assets/images/bebin-logo.svg`).default;
				setFaviconUrl(faviconUrl)
			}

		}

	}, [config]);

	const renderCanonical = () => {
		const canonicalUrl = `https://bebin.com${location.pathname}${location.search}`;

		return (
			<Helmet>
				<link rel="canonical" href={canonicalUrl} />
			</Helmet>
		)
	}

	const renderSeo = () => {
		return(
			<>
				{renderCanonical()}
			</>
		)
	}

	return (
		<AppContext.Provider value={config}>
			{renderSeo()}
			{config && config.titleEn === 'bebin' && !config?.sub_domain ? (
				<Helmet>
					<meta
						content="ببین | مرجع فیلم و سریال رایگان "
						name="description"
					/>

					<meta property="og:url" content={window.location.href} />
					<meta property="og:type" content="website" />

					{faviconUrl ? (
						<link rel="icon" href={faviconUrl} type="image/svg+xml" />
					) : null}

					{/* Google tag (gtag.js) */}
					<script async src="https://www.googletagmanager.com/gtag/js?id=G-FC6ZSKP476"></script>
					<script>
						{`window.dataLayer = window.dataLayer || [];
						function gtag(){dataLayer.push(arguments);}
						gtag('js', new Date());

						gtag('config', 'G-FC6ZSKP476');
						`}
					</script>

					{/* clarity */}
					<script>
						{`(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "pzgs9yx2ic");`}
					</script>
					<script>
						{`var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function()

{     var u="//analytics.dolphinai.ir/";     _paq.push(['setTrackerUrl', u+'matomo.php']);     _paq.push(['setSiteId', '7']);     var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];     g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);   }

)();`}
					</script>
				</Helmet>
			) : (config && config?.titleEn !== 'bebin') || (config?.titleEn === 'bebin' && config?.sub_domain) ? (
				<Helmet>
					{faviconUrl ? (
						<link rel="icon" href={faviconUrl} type="image/svg+xml" />
					) : null}
					<meta
						content={`${config?.title} | مرجع فیلم و سریال رایگان `}
						name="description"
					/>
					<meta property="og:url" content={window.location.href} />
					<meta property="og:type" content="website" />
				</Helmet>
			): null}
			{children}
		</AppContext.Provider>
	);
};

export const useConfigApp = () => useContext(AppContext);
